<div id="splash-container" class="container-fluid" [style.background]="'url(../../../assets/organisation/images/background.png)'">
  <div class="row">
    <div class="col-md">
      <div id="splash">
        <img src="../../../assets/organisation/images/logo.png" [alt]="'IMAGE_ALT.LOGO' | translate" />
      </div>
    </div>
  </div>
</div>
